import { render, staticRenderFns } from "./FormInputGroup.vue?vue&type=template&id=1870b4df&"
import script from "./FormInputGroup.vue?vue&type=script&lang=js&"
export * from "./FormInputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports